import React, {useRef, useState} from "react"
import Styles from "./muticard.less"

import classNames from "classnames"

import prevImg from "../images/前翻.svg"
import nextImg from "../images/后翻.svg"

export const MutiCard = ({list, onMouseLeave, onMouseEnter}) => {
    const width = 300
    const length = list.length

    const [activeIndex, setActiveIndex] = useState(0)

    const dis = -activeIndex * width

    let listStyle = {
        transform: `translate3d(${dis}px, 0, 0)`,
        transition: " all 500ms ease 0s",
    }

    const listRef = useRef(null)

    const handleNext = () => {
        setActiveIndex((currentActiveIndex) => ++currentActiveIndex)
    }

    const handlePrev = () => {
        setActiveIndex((currentActiveIndex) => --currentActiveIndex)
    }

    const activeLeft = dis < 0
    const activeRight = dis > -width * (length - 1)

    const prevClasses = classNames(Styles["btn"], Styles["prev-btn"], {
        [Styles["un_active"]]: !activeLeft,
    })
    const nextClasses = classNames(Styles["btn"], Styles["next-btn"], {
        [Styles["un_active"]]: !activeRight,
    })
    const footerClasses = classNames(Styles["footer"], {
        [Styles["un_display"]]: length <= 1,
    })

    return (
        <div className={Styles["wrapper"]} onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
            <div style={listStyle} className={Styles["list"]} ref={listRef}>
                {list}
            </div>
            <div className={footerClasses}>
                <img onClick={handlePrev} className={prevClasses} src={prevImg} />
                <span>
                    {activeIndex + 1} / {list.length}
                </span>
                <img onClick={handleNext} className={nextClasses} src={nextImg} />
            </div>
        </div>
    )
}
